import { INDEXED_SEARCH_PATH } from 'constants/main';

const categoryNameConstruct = (category?: string, subCategory?: string) => {
  let finalCategory = category;
  const newCategoryPage = category === INDEXED_SEARCH_PATH;

  if (newCategoryPage) {
    finalCategory = encodeURIComponent(`${category}/${subCategory}`);
  }

  return { finalCategory, newCategoryPage };
};

export default categoryNameConstruct;
